import { Grid, Link } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  logo: { display: 'flex', margin: 'auto', marginTop: '30px', marginBottom: '25px' },
  headingLinkLeft: { textAlign: 'left', padding: 20 },
  headingLinkRight: { textAlign: 'right', padding: 20 },
}));

export default function LoginSignUpBanner() {
  const classes = useStyles();
  return (
    <>
      <Grid container>
        <Grid item xs={6} className={classes.headingLinkLeft}>
          <Link href="https://www.trustate.com">Take me back to the homepage</Link>
        </Grid>
        <Grid item xs={6} className={classes.headingLinkRight}>
          <Link href="https://meetings.hubspot.com/tara-faquir/trusuite-15-min-onboarding">
            Book a 15-minute demo!
          </Link>
        </Grid>
      </Grid>
      <Link href="https://www.trustate.com">
        <img src={'/logo-light-stacked.svg'} alt="Trustate Logo" className={classes.logo} />
      </Link>
    </>
  );
}
